import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EFileExtension, EFromFilePlace } from '../../../../helpers';
import { GQLFile, GQLFileTypeEnum } from '../../../../../../schemas/schemas';
import { Observable, of } from 'rxjs';

import { DialogService } from 'primeng/dynamicdialog';
import { EFileListType } from '../../../../types/EFileListType';
import { FullscreenGalleryComponent } from '../../../fullscreen-gallery/components/fullscreen-gallery/fullscreen-gallery.component';
import { Store } from '@ngrx/store';
import { tryRemoveFile } from '../../../../store/files/files.actions';

@Component({
  selector: 'app-files-widget',
  templateUrl: './files-widget.component.html',
  styleUrls: ['./files-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilesWidgetComponent {
  @Input() fileListType: EFileListType = EFileListType.PROJECT;
  @Input() files$: Observable<GQLFile[] | null> = of(null);

  readonly fileTypeEnum = GQLFileTypeEnum;

  constructor(
    private readonly store: Store,
    private readonly dialogService: DialogService,
  ) {}

  get filePlace(): EFromFilePlace {
    return this.fileListType === EFileListType.PROJECT
      ? EFromFilePlace.PROJECT_WIDGET
      : EFromFilePlace.THREAD_WIDGET;
  }

  openFileViewer(file: GQLFile): void {
    if (file?.versions?.[0].extension === EFileExtension.PDF) {
      const dialogConfig = {
        data: {
          fileList$: this.files$,
          activeFile: file,
          isPrevNextArrowsNeed: false,
        },
        styleClass: 'gallery',
        width: '100%',
        height: '100%',
      };

      this.dialogService.open(FullscreenGalleryComponent, dialogConfig);
    }
  }

  removeFile(file: GQLFile): void {
    this.store.dispatch(tryRemoveFile({ id: file.id, fileName: file.name }));
  }

  getFilesShortList(files: GQLFile[]): GQLFile[] {
    return files?.slice(0, 6);
  }
  trackByFn(index: number, item: GQLFile): string {
    return item.id || index.toString();
  }
}
